import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import css from "./Calculator.module.css";
import { selectStyle } from "./selectStyle";
import { useAuctionFee } from "../../../../hooks/useAuctionFee";
import { AppContext } from "../../../../providers/appProvider";
import { formatUsdAndGel } from "../../../../utils/currency";

const auctionOptions = [
  { value: "auctionwini", label: "auctionwini" },
  { value: "copart", label: "copart" },
  { value: "iaai", label: "iaai" },
];

const parseNumber = (value) => {
  if (value == null) return null;
  const normalized = String(value).replace(",", ".");
  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

const findMatchingRule = (rules, bidAmount) => {
  const bid = parseNumber(bidAmount);
  if (bid == null) return null;

  const matches = rules.filter((rule) => {
    const minBid = parseNumber(rule.min_bid) ?? 0;
    const maxBid = parseNumber(rule.max_bid);
    const max = maxBid == null ? Number.POSITIVE_INFINITY : maxBid;
    return bid >= minBid && bid <= max;
  });

  matches.sort((a, b) => (parseNumber(b.min_bid) ?? 0) - (parseNumber(a.min_bid) ?? 0));
  return matches[0] ?? null;
};

const AuctionFees = () => {
  const { auctionFeeService } = useAuctionFee();
  const { t } = useTranslation();
  const { appState } = useContext(AppContext);

  const [bidAmount, setBidAmount] = useState("");
  const [auction, setAuction] = useState(null);

  useEffect(() => {
    auctionFeeService.fetch();
  }, []);

  const selectedAuctionOption = useMemo(() => {
    if (auction == null) return null;
    return auctionOptions.find((opt) => opt.value === auction) ?? null;
  }, [auction]);

  const rulesForAuction = useMemo(() => {
    if (auction == null) return [];
    return auctionFeeService.items.filter((item) => item.auction === auction);
  }, [auction, auctionFeeService.items]);

  const matchedRule = useMemo(
    () => findMatchingRule(rulesForAuction, bidAmount),
    [rulesForAuction, bidAmount]
  );

  const bid = useMemo(() => parseNumber(bidAmount), [bidAmount]);
  const fixedFee = useMemo(() => parseNumber(matchedRule?.fee) ?? 0, [matchedRule]);
  const percent = useMemo(() => parseNumber(matchedRule?.procent) ?? 0, [matchedRule]);
  const percentFee = useMemo(() => {
    if (bid == null || percent === 0) return 0;
    if (auction === "copart") {
      return 1190 + (bid - 15001) * percent / 100;
    }
    if (auction === "iaai") {
      return 1190 + (bid - 15000) * percent / 100;
    }
    return (bid * percent) / 100;
  }, [bid, percent, auction]);
  const totalFee = useMemo(() => fixedFee + percentFee, [fixedFee, percentFee]);

  return (
    <div className={css.colBox}>
      <h1 className={css.colTitle}>{t("AuctionFees")}</h1>

      <div className={css.inp2colCar} style={{ marginBottom: 0 }}>
        <div style={{ width: "50%" }}>
          <div className={css.bigtran}>
            <div className={css.horTitle}>{t("Amount")}</div>
            <input
              type="number"
              step="0.01"
              min="0"
              value={bidAmount}
              onChange={(e) => setBidAmount(e.target.value)}
              className={css.inputDownPort}
              placeholder="0.00"
              disabled={auctionFeeService.isLoading}
            />
          </div>
        </div>

        <div style={{ width: "50%" }}>
          <div className={css.bigtran}>
            <div className={css.horTitle}>{t("Auction")}</div>
            <Select
              value={selectedAuctionOption}
              onChange={(opt) => setAuction(opt?.value ?? null)}
              options={auctionOptions}
              isClearable
              isLoading={auctionFeeService.isLoading}
              isDisabled={auctionFeeService.isLoading}
              placeholder={auctionFeeService.isLoading ? `${t("Loading")}...` : t("SelectAuction")}
              styles={selectStyle}
            />
          </div>
        </div>
      </div>

      {(auction === "copart" || auction === "iaai") && (
        <div style={{ color: "red", margin: "10px 0" }}> 
         {t("CalculateFeeWarning")}
        </div>
      )}

      <div className={css.transPriceBottom}>
        <div className={css.bigtran} style={{ padding: "5px 20px 10px 20px", display: 'none' }}> 
          <div className={css.commentBox}>
            {auction == null || bid == null
              ? "-"
              : matchedRule == null
                ? "-"
                : `${t("MinBid")}: ${matchedRule.min_bid} | ${t("MaxBid")}: ${matchedRule.max_bid}`}
          </div>
        </div>

        <div>
          
        </div>

        <div className={css.TitlePrice}>
          <div className={css.transText}>{t("Fee")}</div>
          <span>
            {formatUsdAndGel(
              auction == null || bid == null || matchedRule == null ? 0 : totalFee,
              appState.currencies,
              2
            )}
          </span>
        </div>

        {/*
        <div className={css.TitlePrice} style={{display: 'none'}}>
          <div className={css.transText}>{t("Procent")}</div>
          <span>{auction == null || matchedRule == null ? "0" : percent} %</span>
        </div>

        <div className={css.TitlePrice} style={{display: 'none'}}>
          <div className={css.transText}>{t("Fee")}</div>
          <span>{auction == null || matchedRule == null ? "0.00" : formatMoney(fixedFee)} $</span>
        </div>
        */}
      </div>
    </div>
  );
};

export default AuctionFees;
